<template>
    <div>
        <div class="d-sm-down-none">
            <CRow>
                <CCol sm="6" style="background-size: cover; display: flex; align-items: center; justify-content: center; min-height: 100vh;" class="bg-white">
                    <CContainer style="max-width: 600px; text-align: left;">
                        <div>
                            <h3 class="custom-32px-500 font-color-171717 text-left">Set Up a New Password</h3>
                            <p class="custom-18px-500">Password should be long enough, unique to you, and difficult for other to guess.</p>
                        </div>
    
                       
    
                        <div class="mt-3">
                            <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-101010">New Password</strong>
                            <input type="password" class="custom-input-app mb-2 mt-2" v-model="newPassword" />
                        </div>
                        <div class="mt-3">
                            <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-101010">Confirm Password</strong>
                            <input type="password" class="custom-input-app mb-2 mt-2" v-model="confirmPassword" />
                        </div>
                        <div style="clear:both"></div>
                        <div class="text-center mt-5">
                            <span class="custom-border-purple p-2 text-center text-white" v-on:click="ChangePassword">
                                    <label class="ml-2 mr-2">Set New Password</label>
                                </span>
                            <br />
                            <label class="font-color-928AFD mt-4">Back to Login</label>
                        </div>
                    </CContainer>
                </CCol>
    
                <CCol sm="6" lg="6" style="background-size: cover; background-position: center; min-height: 100vh;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
                    <CRow class="mt-3 p-3">
                        <CCol sm="6">
                            <img src="../assets/img/Logo(1).png" height="32" alt="Interviewrr.ai company logo" />
                            <span class="custom-20px-500 text-white">Interviewrr</span>
                        </CCol>
                        <CCol sm="6"></CCol>
                        <CCol sm="12">
                            <h3 class="custom-32px-700 text-white mt-5">Boost Retention with a Loyalty Program</h3>
                            <p class="custom-18px-400 text-white">
                                A loyalty program strengthens relationships, encourages repeat business, and enhances customer satisfaction. Start rewarding your customers today!
                            </p>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
        </div>
        <div class="d-md-none d-lg-none bg-white"></div>
    </div>
</template>

<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgthird.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            newPassword: "",
            confirmPassword: "",

            // email: this.$router.query.email,
            // code: this.$route.query.code





        };
    },


    methods: {
        ChangePassword() {
      const formData = new FormData();

      formData.append("userEmail", this.$route.query.email);
       formData.append("code", this.$route.query.code);
        formData.append("newPassword", this.newPassword);

      return this.$API
        .post(this.$ChangePassword, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.$router.push("/Login");
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

            this.ErrorMessage = true;
          }
        });
    },



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>
